// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"70c963f2","453":"19fe3978","627":"572c8338","738":"81112014","923":"8906309c"}[chunkId] + ".chunk.js";
};